import { getTimeSpanParts, TIME_SPAN_UNITS } from 'tradera-utils/date';
import { formatEndDate } from './format';

const DAY_IN_SECONDS = 24 * 60 * 60;
const HOUR_IN_SECONDS = 60 * 60;
const MINUTE_IN_SECONDS = 60;

const TIME_LEFT_DAY_LIMIT = 24 * 60 * 60;
const TIME_LEFT_HOUR_LIMIT = 60 * 60;
const TIME_LEFT_MINUTE_LIMIT = 60;

export const formatVipTimeLeft = (secondsLeft, t) => {
    const hoursOrEmpty = (hours, t) =>
        hours ? t('vip_hours', { count: hours }) : '';

    const minutesOrEmpty = (minutes, t) =>
        minutes ? t('vip_minutes', { count: minutes }) : '';

    if (secondsLeft < 1) {
        return '';
    }
    let formattedTimeLeft;
    if (secondsLeft > TIME_LEFT_DAY_LIMIT) {
        const { days, hours } = getTimeSpanParts(secondsLeft, {
            endUnit: TIME_SPAN_UNITS.HOURS
        });
        formattedTimeLeft = (
            t('vip_days', { count: days }) +
            ' ' +
            hoursOrEmpty(hours, t)
        ).trim();
    } else if (secondsLeft > TIME_LEFT_HOUR_LIMIT) {
        const { hours, minutes } = getTimeSpanParts(secondsLeft, {
            startUnit: TIME_SPAN_UNITS.HOURS,
            endUnit: TIME_SPAN_UNITS.MINUTES
        });
        formattedTimeLeft = (
            t('vip_hours', { count: hours }) +
            ' ' +
            minutesOrEmpty(minutes, t)
        ).trim();
    } else if (secondsLeft > TIME_LEFT_MINUTE_LIMIT) {
        const { minutes, seconds } = getTimeSpanParts(secondsLeft, {
            startUnit: TIME_SPAN_UNITS.MINUTES,
            endUnit: TIME_SPAN_UNITS.SECONDS
        });
        formattedTimeLeft =
            t('vip_minutes', { count: minutes }) +
            ' ' +
            t('vip_seconds', { count: seconds || 0 });
    } else {
        formattedTimeLeft = t('vip_seconds', { count: secondsLeft });
    }
    return formattedTimeLeft;
};

export const formatItemCardTimeLeft = (
    secondsLeft,
    t,
    endDate,
    serverDate,
    dayjs
) => {
    if (Number.isInteger(secondsLeft)) {
        if (secondsLeft > DAY_IN_SECONDS) {
            return formatEndDate(endDate, t, serverDate, dayjs);
        }

        if (secondsLeft > HOUR_IN_SECONDS) {
            const ifValueNotZeroShowLabel = (label, value) =>
                value > 0 ? ' ' + t(label, { count: value }) : '';
            const hours = Math.floor(secondsLeft / HOUR_IN_SECONDS);
            const minutes = Math.floor(
                Math.floor(secondsLeft % HOUR_IN_SECONDS) / MINUTE_IN_SECONDS
            );
            return (
                t('vip_hours', { count: hours }) +
                ifValueNotZeroShowLabel('vip_minutes', minutes)
            );
        }

        if (secondsLeft > 2 * MINUTE_IN_SECONDS) {
            const minutes = Math.floor(secondsLeft / MINUTE_IN_SECONDS);
            return t('vip_minutes', { count: minutes });
        }

        return t('vip_seconds', { count: secondsLeft });
    } else {
        return '';
    }
};
